
<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="关键字">
              <a-input v-model="queryParam.keywords" allowClear  placeholder="搜索关键字"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="赛季赛区">
              <a-cascader @change="onSjsqChange" :options="sjsqOptions" :fieldNames="{ label: 'name', value: 'id', children: 'children' }" placeholder="请选择赛区" v-model="queryParam.sjsq" changeOnSelect />
            </a-form-item>
          </a-col>

          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="省市">
                <a-cascader :options="areaOptions" placeholder="请选择地区" v-model="queryParam.namekeys" changeOnSelect
                />
              </a-form-item>
            </a-col>
            </a-col>

          </template>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px" >
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator" >
    <!--  <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item v-for="(hotel,hindex) in hotelOptions" @click="setHotel(hotel.id)" :key="hindex">{{hotel.name}}</a-menu-item>
          <a-menu-item v-show="hotelOptions.length==0" disabled >请先选择赛区或者当前赛区未配置酒店信息</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          设置酒店 <a-icon type="setting" />
        </a-button>
      </a-dropdown>

      <a-button v-if="selectedRowKeys.length > 0" @click="unSetHotel()" style="margin-left: 8px"  >
        取消酒店 <a-icon type="setting" />
      </a-button>-->

<!--      <a-button @click="download(1)" style="margin-left: 8px"  >-->
<!--        酒店交通安排表(导出) <a-icon type="download" />-->
<!--      </a-button>-->


    </div>

    <s-table
            ref="table"
            size="default"
            :columns="columns"
            :data="loadData"
            :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
            :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >
      <span slot="danwei" slot-scope="text,record">
          <div style="margin-left: 10px; float: left">
            {{record.danwei}}<br/>
            {{record.saiqu_name}}
            <br/><span style="color: #999">{{record.mingcheng}}</span>
            <br/>
            {{record.create_time|timeFormat}}
            <br/>
          </div>
      </span>
      <span slot="status" slot-scope="text,record">

        <p>酒店
          <editable-cell :text="text" @change="onEditChange(record.id, 'hotel_name', $event)"/>
        </p>
        <p>交通
          <editable-cell :text="text" @change="onEditChange(record.id, 'bus_name', $event)"/>
        </p>
        <p>接站
          <editable-cell :text="text" @change="onEditChange(record.id, 'bus_take_come_name', $event)"/>
        </p>
        <p>送站
          <editable-cell :text="text" @change="onEditChange(record.id, 'bus_take_go_name', $event)"/>
        </p>
        <p>用餐
          <editable-cell :text="text" @change="onEditChange(record.id, 'dinner', $event)"/>
        </p>

      </span>
      <span slot="action" slot-scope="text,record">
        <template >
          <a-badge :number-style="{ backgroundColor: '#faad14' }"  :count="record.edit_todo_count">
            <!--<a @click="handleEdit(record)">编辑</a>-->
          </a-badge>
          <a-divider type="vertical" />
        </template>
      </span>
    </s-table>




  </a-card>
</template>

<script>
  import STable from '@/components/table/'
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  import AInput from 'ant-design-vue/es/input/Input'
  import EditableCell from '@/components/EditableCell/'
  import PicUploader from '@/components/PicUploader/'
  import FileUploader from '@/components/FileUploader/'
  import JiaolianPicker from '@/components/JiaolianPicker/'
  import CaipanPicker from '@/components/CaipanPicker/'
  import areaOptions from '@/utils/area'
  import moment from 'moment'
  import setting from '@/config/setting'
  import 'moment/locale/zh-cn';
  moment.locale('zh-cn');

  import { getConfrimApplyList ,editTrans,sjsqOptions,hotelOptions,setHotel,unSetHotel} from '@/api/sai'
  export default {
    name: 'KaojiApplyList',
    components: {
      AInput,
      ATextarea,
      FileUploader,
      PicUploader,
      STable,
      EditableCell,
      CaipanPicker,
      JiaolianPicker,
    },
    data () {
      return {
        areaOptions,
        visible: false,
        orderVisible: false,
        saveLoading:false,
        jiaolianPickerShow:false,
        caipanPickerShow:false,
        sjsqOptions:[],
        hotelOptions:[],
        orderFormData:{

        },
        formData:{
          id:0,
          danwei:'',
          mingcheng:'',
          datetitle_moment:null,
          datetitle:'',
          heying:[],
          jiaolian:[],
          caipan:[],
          subjectlist:[],
          loglist:[],
        },
        time_range_moment:[],
        time_range:[],
        labelCol: {
//          xs: { span: 24 },
//          sm: { span: 5 },
          xs: { span: 24 },
          sm: { span: 8 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12 },
        },
        form: this.$form.createForm(this),
        mdl: {},

        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {
          keywords:'',
          sjsq:[]
        },
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: 'id',
            width: '50px'
          },
          {
            title: '报名信息',
            dataIndex: 'danwei',
            scopedSlots: { customRender: 'danwei' },
          },
                
          {
            title: '状态',
            dataIndex: 'status',
            width: '200px',
            scopedSlots: { customRender: 'status' },
          },
                
          {
            title: '操作',
            dataIndex: 'action',
            fixed: 'right',
            width: 220,
            scopedSlots: { customRender: 'action' },
          }
        ],
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          console.log('loadData');
          console.log(this.queryParam);
          let that= this;

          if (this.time_range_moment[0] && this.time_range_moment[1]) {
            this.queryParam.time_range = [
              this.time_range_moment[0].format('YYYY-MM-DD HH:mm:ss'),
              this.time_range_moment[1].format('YYYY-MM-DD HH:mm:ss')
            ]
          } else {
            this.queryParam.time_range = []
          }

          this.queryParam = Object.assign(this.queryParam,parameter);
          return getConfrimApplyList(this.queryParam)
                  .then(res => {
                    console.log('res');
                    return res.data
                  })
        },

        selectedRowKeys: [],
        selectedRows: [],
        cashFormData:{
          ids:[],
          to_type:'',
          price:0,
          note:'',
          count:0,
        }
      }
    },
    computed:{
    },
    created(){
    },

    mounted(){
      let that = this;
      that.getSjsqOptions();
    },
    methods: {
      moment,
      getSjsqOptions(){
        let that = this;
        sjsqOptions({}).then(res =>{
          that.sjsqOptions = res.data;
        });
      },

      download(type){
        console.log('this.queryParam')
        console.log(this.queryParam)
        if(typeof this.queryParam.sjsq == 'undefined' || this.queryParam.sjsq.length !=2){
          this.$message.error('请先选择赛区');
          return ;
        }
        switch (type){
          case 1:
            window.open(setting.apiBaseURL+'/wyhadminapi/sai/bussettableout?saiqu='+this.queryParam.sjsq[1]);
            break;

        }
      },

      onEditChange(key, dataIndex, value) {
        let self = this;
        editTrans({
          id: key,
          value:value,
          type:dataIndex
        }).then(res => {
          self.$refs.table.refresh(false)
        }).catch(err =>{
          self.$message.error(err.data.msg)
        })
      },

      onSjsqChange(value){
        let that = this;
        if(value.length ==2){
          console.log(value);
          that.getHotelOptions(value[1]);
        }
      },
      getHotelOptions(saiqu){
        let that = this;
        console.log(saiqu);
        hotelOptions({
          saiqu:saiqu
        }).then(res =>{
          that.hotelOptions = res.data;
        });
      },
      setHotel(hotel_id){
        let that = this;
        setHotel({
          hotel_id:hotel_id,
          ids:that.selectedRowKeys,
        }).then(res =>{
          that.$message.success('设置成功')
          that.$refs.table.refresh()
        });
      },
      unSetHotel(hotel_id){
        let that = this;
        unSetHotel({
          ids:that.selectedRowKeys,
        }).then(res =>{
          that.$message.success('取消成功')
          that.$refs.table.refresh()
        });
      },
      //展开关闭
      toggleAdvanced() {
        this.advanced = !this.advanced
      },

      // 查
      onSearch() {
        let self = this;
        self.$refs.table.refresh(false)
      },
      onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },

    },
    filters:{
    },
    watch: {
    }
  }
</script>
